<template>
  <div class="embed-responsive embed-responsive-16by9">
    <iframe class="embed-responsive-item" src="https://gestion.dialnet.net.co/index.php" allowfullscreen></iframe>
  </div>
</template>

<script>

  export default {
    mounted(){
      this.$emit('cotentLoading')
    }
  }
  </script>
